import { render, staticRenderFns } from "./text-templates-modal-basic-form.vue?vue&type=template&id=2200b86a&scoped=true&"
import script from "./text-templates-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./text-templates-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./text-templates-modal-basic-form.scss?vue&type=style&index=0&id=2200b86a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2200b86a",
  null
  
)

export default component.exports